var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssessmentStepFour = function SvgAssessmentStepFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#248BF2",
    d: "M0 6.5h135"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129.5,
    cy: 6.5,
    r: 6,
    fill: "#fff",
    stroke: "#248BF2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 6.5,
    r: 3.5,
    fill: "#248BF2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 6.5,
    r: 3.5,
    fill: "#248BF2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 6.5,
    r: 3.5,
    fill: "#248BF2"
  })));
};
export { SvgAssessmentStepFour as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='136' height='13' viewBox='0 0 136 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cline x1='-4.37114e-08' y1='6.5' x2='135' y2='6.49999' stroke='%23248BF2'/%3E %3Ccircle cx='129.5' cy='6.5' r='6' fill='white' stroke='%23248BF2'/%3E %3Ccircle cx='3.5' cy='6.5' r='3.5' fill='%23248BF2'/%3E %3Ccircle cx='44.5' cy='6.5' r='3.5' fill='%23248BF2'/%3E %3Ccircle cx='85.5' cy='6.5' r='3.5' fill='%23248BF2'/%3E %3C/svg%3E";